import React, { useState } from "react";
import ReactCustomModal from "components/CustomModal/ReactCustomModal";
import Refresh from "assets/img/icons/refresh.svg";
import backGroundImage from "assets/img/background-poll.jpeg";
import UserAssessmentQuestion from "components/UserAssessment/UserAssessmentQuestion";
import UserAssessmentReviews from "components/UserAssessment/UserAssessmentReviews";
import UserAssessmentActions from "components/UserAssessment/UserAssessmentActions";
import UserAssessmentRefresh from "components/UserAssessment/UserAssessmentRefresh";
import UserService from "services/UserService";
import { useToasts } from "react-toast-notifications";

export default ({ openModal, setOpenModal }) => {
  const [questionCount, setQuestionCount] = useState(1);
  const [questionReviews, setQuestionReviews] = useState([]);
  const [questionError, setQuestionError] = useState(false);
  const [openRefreshModal, setOpenRefreshModal] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [clickSubmitName, setClickSubmitName] = useState("");
  const { addToast } = useToasts();

  const closeRefreshModal = () => {
    setQuestionCount(1);
    setQuestionReviews([]);
    setQuestionError(false);
    setOpenRefreshModal(false);
  };
  const onCloseModal = () => {
    setOpenModal(false);
  };
  const nextQuestion = (value, questionId) => {
    setQuestionError(false);
    if (value === "next") {
      const data = questionReviews?.map((item) => {
        return item.q1 && item.q2 && item.id;
      });
      data.includes(questionId)
        ? setQuestionCount(questionCount + 1)
        : setQuestionError(true);
    } else {
      setQuestionReviews(
        questionReviews.filter((item) => item.id === questionId)?.length > 0
          ? questionReviews.slice().map((data) => {
              if (data.id === questionId) {
                return {
                  ...data,
                  q1: "",
                  q2: "",
                };
              }
              return data;
            })
          : [...questionReviews, { id: questionId, q1: "", q2: "" }]
      );
      setQuestionCount(questionCount + 1);
    }
  };
  const handleOnSubmit = async (value) => {
    setClickSubmitName(value);
    setSaveLoading(true);
    try {
      const response = await UserService.updateNetThrivingScore(
        questionReviews
      );
      setSaveLoading(false);
      setOpenRefreshModal(false);
      setClickSubmitName("");
      addToast(
        response?.data?.message || "User net thriving score has been updated!",
        {
          appearance: "success",
        }
      );
      setSaveLoading(false);
      setOpenModal(false);
    } catch (err) {
      setSaveLoading(false);
      setClickSubmitName("");
      addToast(err?.response?.data?.message || err?.message, {
        appearance: "error",
      });
    }
  };
  return (
    <>
      <ReactCustomModal
        closeDialog={onCloseModal}
        modelOpen={openModal}
        modalHeaderClass={"assessmentModal"}
        modalClass={"assessmentModalClass"}
        headerChildren={
          <>
            <div>
              <img
                src={Refresh}
                alt="Back"
                className="refresh"
                width={"20px"}
                height={"20px"}
                onClick={() => setOpenRefreshModal(true)}
              />
            </div>
            <h5>{"Assessment"}</h5>
          </>
        }
      >
        <div
          className={"assessmentRootContent"}
          style={{ backgroundImage: `url(${backGroundImage})` }}
        >
          <div className="assessmentQuestionCount">
            <h5>{questionCount}/5</h5>
          </div>
          <div className="assessmentMainContent">
            <UserAssessmentQuestion questionCount={questionCount} />
            <UserAssessmentReviews
              questionCount={questionCount}
              setQuestionReviews={setQuestionReviews}
              questionReviews={questionReviews}
            />
            <UserAssessmentActions
              nextQuestion={nextQuestion}
              questionCount={questionCount}
              handleOnSubmit={handleOnSubmit}
              saveLoading={saveLoading}
              clickSubmitName={clickSubmitName}
            />
            {questionError && (
              <div className="error-msg">
                Please select one of the values for where you stand now and
                after five years
              </div>
            )}
          </div>
        </div>
      </ReactCustomModal>
      {openRefreshModal && (
        <UserAssessmentRefresh
          openRefreshModal={openRefreshModal}
          setOpenRefreshModal={setOpenRefreshModal}
          closeRefreshModal={closeRefreshModal}
        />
      )}
    </>
  );
};
